// @ngInject
Filters.SnakecaseFilter  = function SnakecaseFilter($filter) {
    return function(text) {
        var snake_case = text.toLowerCase().replace(/ +/g,'_');
        return snake_case;
    };
};